/* ===========================================================================
   Pincode delivery + COD checker (snippets/ddc-delivery-check.liquid)

   No backend. A 6-digit Indian PIN (not starting with 0) is matched against
   the prefix lists from Theme settings > Delivery checker; the longest
   matching prefix wins, and remote wins a tie with metro. The estimate is
   today + dispatch days + delivery days, counted in business days
   (Mon-Sat, Sundays skipped). The last PIN is remembered in localStorage.
   Only the zone (never the PIN) goes to the dataLayer, and only locally.
   ========================================================================= */
(function () {
  "use strict";

  var root = document.querySelector("[data-ddc-pin]");
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(root.querySelector("[data-ddc-pin-config]").textContent) || {}; } catch (e) { return; }

  var form = root.querySelector("[data-ddc-pin-form]");
  var input = root.querySelector("[data-ddc-pin-input]");
  var out = root.querySelector("[data-ddc-pin-result]");
  var KEY = "ddc_pincode";
  var msg = cfg.msg || {};

  function list(text) {
    return String(text || "").split(/[^0-9]+/).filter(function (p) { return p.length >= 1 && p.length <= 6; });
  }
  var METRO = list(cfg.metro);
  var REMOTE = list(cfg.remote);
  var NO_COD = list(cfg.noCod).filter(function (p) { return p.length === 6; });

  function int(n, d) { n = parseInt(n, 10); return isNaN(n) || n < 0 ? d : n; }
  function range(pair, a, b) {
    pair = pair || [];
    var lo = int(pair[0], a), hi = int(pair[1], b);
    return hi < lo ? [hi, lo] : [lo, hi];
  }
  var DISPATCH = range(cfg.dispatch, 1, 2);
  var DAYS = cfg.days || {};
  var ZONES = { metro: range(DAYS.metro, 2, 4), rest: range(DAYS.rest, 4, 7), remote: range(DAYS.remote, 7, 10) };

  function valid(pin) { return /^[1-9][0-9]{5}$/.test(pin); }

  function longest(pin, prefixes) {
    var best = 0;
    prefixes.forEach(function (p) { if (p.length > best && pin.indexOf(p) === 0) best = p.length; });
    return best;
  }
  function zoneOf(pin) {
    var m = longest(pin, METRO), r = longest(pin, REMOTE);
    if (r && r >= m) return "remote";
    if (m) return "metro";
    return "rest";
  }

  /* n business days after `from` (Sundays do not count). */
  function addBusinessDays(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) n--;
    }
    return d;
  }

  var DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  function fmt(d, withMonth) { return DOW[d.getDay()] + " " + d.getDate() + (withMonth ? " " + MON[d.getMonth()] : ""); }
  function dates(a, b) {
    if (a.getTime() === b.getTime()) return fmt(a, true);
    return fmt(a, a.getMonth() !== b.getMonth()) + " – " + fmt(b, true);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function show(pin) {
    out.textContent = "";
    root.classList.remove("is-error", "is-done");
    if (!valid(pin)) {
      root.classList.add("is-error");
      input.setAttribute("aria-invalid", "true");
      out.appendChild(el("p", "ddc-pin__msg ddc-pin__msg--error", msg.invalid || "Enter a valid 6-digit pincode"));
      return false;
    }
    input.removeAttribute("aria-invalid");

    var zone = zoneOf(pin);
    var days = ZONES[zone];
    var today = new Date();
    var from = addBusinessDays(today, DISPATCH[0] + days[0]);
    var to = addBusinessDays(today, DISPATCH[1] + days[1]);
    var cod = NO_COD.indexOf(pin) === -1;

    var eta = el("p", "ddc-pin__msg ddc-pin__msg--eta");
    var etaText = String(msg.eta || "Get it by {dates}");
    var parts = etaText.split("{dates}");
    eta.appendChild(document.createTextNode(parts[0]));
    if (parts.length > 1) {
      eta.appendChild(el("b", null, dates(from, to)));
      eta.appendChild(document.createTextNode(parts.slice(1).join("")));
    }
    eta.appendChild(document.createTextNode(" "));
    eta.appendChild(el("span", "ddc-pin__pin", "(" + pin + ")"));
    out.appendChild(eta);

    var facts = el("ul", "ddc-pin__facts");
    facts.setAttribute("role", "list");
    if (msg.free) facts.appendChild(el("li", "is-yes", msg.free));
    if (cod && msg.cod) facts.appendChild(el("li", "is-yes", msg.cod));
    if (!cod && msg.noCod) facts.appendChild(el("li", "is-no", msg.noCod));
    if (facts.children.length) out.appendChild(facts);
    if (msg.note) out.appendChild(el("p", "ddc-pin__note", msg.note));

    root.classList.add("is-done");
    try { window.localStorage.setItem(KEY, pin); } catch (e) {}
    return { zone: zone, cod: cod };
  }

  function check(fromUser) {
    var pin = String(input.value || "").replace(/\D/g, "").slice(0, 6);
    input.value = pin;
    var r = show(pin);
    if (r && fromUser && typeof window.ddcTrack === "function") {
      window.ddcTrack("delivery_check", { delivery_zone: r.zone, cod_available: r.cod }, { local: true });
    }
  }

  form.addEventListener("submit", function (e) { e.preventDefault(); check(true); });

  // Digits only while typing; check straight away on the sixth digit.
  input.addEventListener("input", function () {
    var clean = input.value.replace(/\D/g, "").slice(0, 6);
    if (clean !== input.value) input.value = clean;
    if (clean.length === 6) check(true);
    else if (root.classList.contains("is-error") || root.classList.contains("is-done")) {
      out.textContent = "";
      input.removeAttribute("aria-invalid");
      root.classList.remove("is-error", "is-done");
    }
  });

  root.hidden = false;

  try {
    var saved = window.localStorage.getItem(KEY);
    if (saved && valid(saved)) { input.value = saved; show(saved); }
  } catch (e) {}

  // For QA in the console: ddcDelivery("110001")
  window.ddcDelivery = function (pin) {
    var p = String(pin || "");
    if (!valid(p)) return null;
    var z = zoneOf(p), d = ZONES[z], t = new Date();
    return { zone: z, from: addBusinessDays(t, DISPATCH[0] + d[0]).toDateString(),
             to: addBusinessDays(t, DISPATCH[1] + d[1]).toDateString(), cod: NO_COD.indexOf(p) === -1 };
  };
})();
